/**
 * Browser polyfills for Node.js APIs required by simple-peer
 */

// Polyfill process.nextTick for browsers
if (typeof process === "undefined") {
  (globalThis as any).process = {
    env: {},
    browser: true,
    version: "v18.0.0",
    nextTick: (fn: Function, ...args: any[]) => {
      setTimeout(() => fn(...args), 0);
    },
  };
} else if (typeof process.nextTick === "undefined") {
  process.nextTick = (fn: Function, ...args: any[]) => {
    setTimeout(() => fn(...args), 0);
  };
}

// Ensure global is available
if (typeof global === "undefined") {
  (globalThis as any).global = globalThis;
}

export {};
